import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import moment from 'moment';

import {
  Localize
} from '../shared';

import {
  getIcon
} from '../../util/icons';

class AssessmentsList extends Component {

  state = {

  }

  // Removed since we want to use page progress instead of response / total question counts to determine progress.
  // calculatePercentCompleteFromAssessment(assessment){
  //
  //   const questionsCount = _.size(assessment.questions);
  //   const responsesCount = _.size(assessment.responses);
  //
  //   return Math.min(Math.floor(responsesCount * 100. / questionsCount), 100);
  // }

  renderAssessment(assessment){

    const {
      createdOn,
      completedOn,
      assessmentConfig,
      status,
      playbookDownloadUrl,
    } = assessment;

    const assessmentIsSubmittedOrComplete = status !== 'inprogress';

    return (
      <div className="assessment" key={assessment._id}>

        <div className="assessment-name"><Localize id={`organization_${assessmentConfig.organization}_label`}> </Localize> <Localize id={`talent_profile_${assessmentConfig.profile}_label`}> </Localize> <Localize id="txt_assessment_label">Assessment</Localize></div>

        {assessmentIsSubmittedOrComplete &&
          <div className="completed-on"><Localize id="txt_label_completed">Completed</Localize> {moment(completedOn.toDate()).format('MMMM D')}</div>
        }
        {!assessmentIsSubmittedOrComplete &&
          <div className="percent-complete"><Localize id="txt_label_in_progress">In Progress</Localize></div>
        }
        <div className="question-action">
          {status === 'inprogress' &&
            <button onClick={() => { this.props.resumeAssessment(assessment); } } className="button blue-button"><Localize id="btn_continue_assessment">Continue assessment</Localize></button>
          }
          {(status === 'complete' || status === 'scoring') &&
            <button disabled className="button blue-button"><Localize id="txt_label_scoring_assessment">Scoring assessment...</Localize></button>
          }
          {status === 'scored' && !assessmentConfig.withholdResults &&
            <a target="_blank" href={playbookDownloadUrl}><button className="button blue-button"><Localize id="btn_view_results">View Results</Localize></button></a>
          }
          {status === 'scored' && assessmentConfig.withholdResults &&
            <p><Localize id="txt_label_playbook_ready_delayed">Your playbook is ready. Your organization will schedule a time for review.</Localize></p>
          }
          {(status === 'complete' || status === 'scoring') &&
            <div className="scoring-assessment-message">
              {getIcon('warning')}
              <p className="assessment-info"><Localize id="txt_label_still_scoring_assessment">We are still scoring this assessment. This usually takes 30-60 seconds.</Localize></p>
              <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div>
          }
        </div>
      </div>
    )
  }

  render(){

    const {
      assessments
    } = this.props;

    return (
      <div id="assessments-list">
        <div className="content-wrapper">
          <h2><Localize id="txt_your_assessments">Your Assessments</Localize></h2>
          <div className="assessments">
            {_.map(assessments, this.renderAssessment.bind(this))}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeLocalization: state.activeLocalization.data
  }
}

export default connect(mapStateToProps, {})(AssessmentsList);



// WEBPACK FOOTER //
// ./src/components/takeAssessment/assessmentsList.js